/**
 * First URL segment under /assets/images/ for files that are only ever
 * in public/ (not Apollo). Route handler only checks disk for these.
 * If missing on disk → 404, no backend fetch.
 */
export const ASSET_IMAGES_LOCAL_ONLY_PREFIXES = ["illustrations", "vendor", "misc"] as const;

export function isAssetImageLocalOnlyBySegments(segments: string[]): boolean {
  if (segments.length < 1) return false;
  return (ASSET_IMAGES_LOCAL_ONLY_PREFIXES as readonly string[]).includes(segments[0]!);
}
